import React, { useEffect, useState } from 'react';
import Table from '../common/Table'; 
import ListOfEventsColumns from './common/dependencies/ListOfCorporateEvent';
import { connect, useDispatch } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { CorporateListOfEvent } from '../../dependencies/services/beneficiary';

const ListOfEvents = (props) => {  
  const  {  eventList, eventPageIndex, eventTotalCount } = props
  const [actions, setActions] = useState({
    pageIndex: eventPageIndex,
    pageSize: 10,
    sortColumn: "yearOfEngagement",
    sortOrder: "desc",
    fetchAllRecords: true
  });
  const dispatch = useDispatch()

  const handleOnPageChange = (pages) => {
    const {page} = pages
    // setActions({ ...actions, pageIndex: page-1 });
      setActions(prev => ({
    ...prev,
    pageIndex: page - 1
  }));
  };

  useEffect(() => {
    dispatch(CorporateListOfEvent(actions))
  },[actions])

  const handleSortChange = ({ dataField }) => {
    const currentOrder = actions.sortOrder.toUpperCase() === "DESC" ? "ASC" : "DESC";
    let sortName = "";
    console.log("list datafield : ", dataField)
    if (dataField === "eventId") {
      sortName = "eventId";
    } else if (dataField === "eventName") {
      sortName = "eventName";
    } else if (dataField === "corporateName") {
      sortName = "corporateName";
    } else if (dataField === "yearOfEngagement") {
      sortName = "yearOfEngagement";
    } else {
      sortName = "createdDate";
    }

    setActions(prev => ({
      ...prev,
      sortColumn: sortName,
      sortOrder: currentOrder
    }));
  };

  return (
    <div>
      {/* Back button */}
      <div className='row'>
        <div className='col-10'>
      
      <h3>List of Events</h3>
      </div>
      <div className='col-2'>
      <button onClick={() => props.history.goBack()} className='bttn blueDarkGradient '>Back</button>

      </div>
      </div>
      <Table
        dataTable={eventList}
        // columns={ListOfEventsColumns({ pageNo: actions.pageIndex })}
        columns={ListOfEventsColumns({
          pageNo: actions.pageIndex,
          onSortChange: handleSortChange, 
          sortColumn: actions.sortColumn,
          sortOrder: actions.sortOrder
        })}
        keyField="id"
        pageNo={actions.pageIndex + 1}
        sizePerPage={actions.pageSize}
        totalSize={eventTotalCount}
        onPageChange={handleOnPageChange}
        // onSortChange={handleTableChange}
      
        
      />
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
      eventList: state.internationalReportList1.eventListData,
      eventTotalCount: state.internationalReportList1.eventTotalCount,
      eventPageIndex: state.internationalReportList1.eventPageIndex,
  }
}

export default connect(mapStateToProps, { })(withRouter(ListOfEvents)); ;
